import React from 'react'
import { useEffect, useState } from 'react'
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import { Link } from "react-router-dom"
import { MDBDataTable } from "mdbreact"
import { AvForm, AvField } from "availity-reactstrap-validation"
import avatar4 from "../../assets/images/users/user-4.jpg"
import Rating from "react-rating"
import {
  Row, Col, CardBody, Card, Container, Label, Input,
  Table, Modal,
  CardTitle, Button,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"

const CustomerDetail = props => {

  const [modal_center, setmodal_center] = useState(false)

  function view_orderDetail() {

    setmodal_center(!modal_center)
    removeBodyCss()
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  const data = {
    columns: [
      {
        label: "Order No.",
        field: "OrderNo",
        sort: "asc",
        width: 150,
      },
      {
        label: "Order Date",
        field: "OrderDate",
        sort: "asc",
        width: 270,
      },
      {
        label: "Branch Name",
        field: "BranchName",
        sort: "asc",
        width: 200,
      },
      {
        label: "Gross Amount",
        field: "GrossAmount",
        sort: "asc",
        width: 100,
      },
      {
        label: "Discount Amount",
        field: "DiscountAmount",
        sort: "asc",
        width: 150,
      },
      {
        label: "Tax Amount",
        field: "TaxAmount",
        sort: "asc",
        width: 100,
      },
      {
        label: "Net Amount",
        field: "NetAmount",
        sort: "asc",
        width: 100,
      },
      {
        label: "View Order",
        field: "ViewOrder",
        sort: "asc",
        width: 100,
      },
    ],
    rows: [
      {
        OrderNo: "1",
        OrderDate: "16/08/2022",
        BranchName: "Sankalp",
        GrossAmount: "820",
        DiscountAmount: "82",
        TaxAmount: "82",
        NetAmount: "820",
        ViewOrder:
          (
            <>
              <Button
                className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
                style={{ width: "25px", height: "25px", padding: "0px" }}
                title="View"
                onClick={() => {
                  setmodal_center(true)
                }}
              >
                <i className="fas fa-eye"></i>
              </Button>
            </>
          ),
      },
    ]
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{props.t("Customer Detail")} | Virtual Supermarket</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumbs
            title={props.t("Home")}
            breadcrumbItem={props.t("Customer Detail")}
          />
          <Card>
            <CardBody>
              <Row>
                <Col md={2} mx={2}>
                  <div>
                    <center><img
                      className="rounded-circle avatar-xl mt-4"
                      alt="veltrix"
                      src={avatar4}
                    /></center>
                  </div>
                </Col>
                <Col md={10}>
                  <AvForm
                    className="form-horizontal"
                  >
                    <Row>
                      <Col md={4} lg={4} sm={12} className="mb-3 mt-6">
                        <Label>Customer Name</Label>
                        <Input readOnly value={"Yana Suthar"}></Input>
                      </Col>
                      <Col md={4} lg={4} sm={12} className="mb-3 ">
                        <Label>Mobile Number</Label>
                        <Input readOnly value={"9638869115"}></Input>
                      </Col>
                      <Col md={4} lg={4} sm={12} className="mb-3">
                        <Label>Email</Label>
                        <Input readOnly value={"yanasuthar34@gmail.com"}></Input>
                      </Col>
                      <Col md={4} lg={4} sm={12} className="mb-3">
                        <Label>Address</Label>
                        <Input rows="5" readOnly value={"Ahmedabad"}></Input>
                      </Col>
                      <Col md={4} lg={4} sm={12} className="mb-3">
                        <Label>Registration Date</Label>
                        <Input readOnly value={"16 / 08 / 2022"}></Input>

                      </Col>
                    </Row>
                  </AvForm>
                </Col>
              </Row>
              <CardTitle style={{ fontSize: "29px" }} className="my-4">Customer Order List</CardTitle>
              <MDBDataTable
                responsive
                bordered
                noBottomColumns
                theadColor={"btn-primary"}
                data={data}
              />
              <Modal
                size='lg'
                isOpen={modal_center}
                toggle={() => {
                  view_orderDetail()
                }}
                centered={true}
              >
                <div className="modal-header">
                  <h5 className="modal-title mt-0">Order Detail</h5>
                  <Button
                    type="button"
                    onClick={() => {
                      setmodal_center(false)
                    }}
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </Button>
                </div>
                <div className="modal-body">
                  {/* <Row>
                    <Col md={4} lg={4} sm={12} className="mb-3">
                      <center>
                        <div>
                          <img
                            className="rounded-circle avatar-XS"
                            alt="veltrix"
                            src={avatar4}
                          />
                        </div>
                      </center>
                    </Col>
                    <Col md={8} lg={8} sm={12} className="mb-3">
                      <Row>
                        <Col md={12} lg={12} sm={12} className="mb-3">
                          <Label><b style={{ fontWeight: 600 }}>Branch Name :</b></Label>
                          <Label>Sankalp</Label>
                        </Col>
                        <Col md={12} lg={12} sm={12} className="mb-3">
                          <Label><b style={{ fontWeight: 600 }}>City :</b></Label>
                          <Label>Ahmedabad, India</Label>
                        </Col>
                        <Col md={6} lg={6} sm={12} className="mb-1">
                          <Label><b style={{ fontWeight: 600 }}>Order Date</b></Label>
                          <Label>: 16/Jun/2022</Label>
                        </Col>
                        <Col md={6} lg={6} sm={12} className="mb-3">
                          <Label><b style={{ fontWeight: 600 }}>Order No.</b></Label>
                          <Label>:#0003698524</Label>

                        </Col>
                      </Row>
                    </Col>
                  </Row> */}
                  <Row>
                    <Col md={3} lg={3} sm={12} className="mb-3">
                      <center>
                        <div>
                          <img
                            className="rounded-circle avatar-lg mt-2"
                            alt="veltrix"
                            src={avatar4}
                          />   </div>
                      </center>
                    </Col>
                    {/* <Col md={4} lg={4} sm={12} className="mb-3  mt-5">
                      <text><b style={{ fontWeight: 600 }}>Branch Name :</b></text>
                      <text>Sankalp</text><br />
                      <text><b style={{ fontWeight: 600 }}>City :</b></text>
                      <text>Ahmedabad, India</text><br />
                    </Col> */}

                    <Col md={9} lg={9} sm={12} className="mb-3 row">
                      {/* <Row> */}
                      <Col md={3} lg={3} sm={3}>
                        <Label><b style={{ fontWeight: 600 }}>Branch Name</b></Label>
                      </Col>
                      <Col md={1} lg={1} sm={1}>
                        <Label>:</Label>
                      </Col>
                      <Col md={8} lg={8} sm={8}>
                        <Label> Sankalp</Label>
                      </Col>
                      <Col md={3} lg={3} sm={3}>
                        <Label><b style={{ fontWeight: 600 }}>City Name </b></Label>
                      </Col>
                      <Col md={1} lg={1} sm={1}>
                        <Label>:</Label>
                      </Col>
                      <Col md={8} lg={8} sm={8}>
                        <Label> Ahmedabad, India</Label>
                      </Col>
                      <Col md={3} lg={3} sm={3}>
                        <Label><b style={{ fontWeight: 600 }}>Order Date</b></Label>
                      </Col>
                      <Col md={1} lg={1} sm={1}>
                        <Label>:</Label>
                      </Col>
                      <Col md={8} lg={8} sm={8}>
                        <Label> 16/Jun/2022</Label>
                      </Col>
                      <Col md={3} lg={3} sm={3}>
                        <Label><b style={{ fontWeight: 600 }}>Order No.</b></Label>
                      </Col>
                      <Col md={1} lg={1} sm={1}>
                        <Label>:</Label>
                      </Col>
                      <Col md={8} lg={8} sm={8}>
                        <Label>#0003698524</Label>
                      </Col>
                      {/* </Row> */}
                    </Col>
                  </Row>
                  <Row>
                    <div className="table-responsive">
                      <Table className="table mb-3">
                        <thead className="table-light" color='btn-primary'>
                          <tr>
                            <th style={{ width: "50%" }}>Item Name</th>
                            <th style={{ width: "15%", textAlign: "right" }}>Quantity</th>
                            <th style={{ width: "15%", textAlign: "right" }}>Rate</th>
                            <th style={{ width: "20%", textAlign: "right" }}>Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>VadaPav</td>
                            <td style={{ textAlign: "right" }}>2</td>
                            <td style={{ textAlign: "right" }}>100.00</td>
                            <td style={{ textAlign: "right" }}>200.00</td>
                          </tr>
                          <tr>
                            <td>Samosa</td>
                            <td style={{ textAlign: "right" }}>1</td>
                            <td style={{ textAlign: "right" }}>50.00</td>
                            <td style={{ textAlign: "right" }}>50.00</td>
                          </tr>
                          <tr>
                            <td>Pizza</td>
                            <td style={{ textAlign: "right" }}>3</td>
                            <td style={{ textAlign: "right" }}>150.00</td>
                            <td style={{ textAlign: "right" }}>450.00</td>
                          </tr>
                          <tr>
                            <td>PavBhaji</td>
                            <td style={{ textAlign: "right" }}>1</td>
                            <td style={{ textAlign: "right" }}>120.00</td>
                            <td style={{ textAlign: "right" }}>120.00</td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </Row>
                  <Row>
                    <Col md={6} lg={6} sm={12} className="mb-1">

                    </Col>
                    <Col md={6} lg={6} sm={12} className="mb-1">
                      <Label md={6} style={{ textAlign: "left", paddingLeft: "15px" }}><b style={{ fontWeight: 600 }}>Item Total :</b></Label>
                      <Label md={6} style={{ textAlign: "right", paddingRight: "15px" }}>820.00</Label>
                    </Col>
                    <Col md={6} lg={6} sm={12} className="mb-1">

                    </Col>
                    <Col md={6} lg={6} sm={12} className="mb-1" >
                      <Label md={6} style={{ textAlign: "left", paddingLeft: "15px" }}><b style={{ fontWeight: 600 }}>Discount :</b></Label>
                      <Label md={6} style={{ textAlign: "right", paddingRight: "15px" }}>82.00</Label>
                    </Col>
                    <Col md={6} lg={6} sm={12} className="mb-1">

                    </Col>                    <Col md={6} lg={6} sm={12} className="mb-1">
                      <Label md={6} style={{ textAlign: "left", paddingLeft: "15px" }}><b style={{ fontWeight: 600 }}>Tax :</b></Label>
                      <Label md={6} style={{ textAlign: "right", paddingRight: "15px" }}>82.00</Label>
                    </Col>

                    <Col md={6} lg={6} sm={12} className="mb-1">

                    </Col>
                    <Col md={6} lg={6} sm={12} className="mb-1">
                      <hr className='mt-0 mb-0'></hr>
                      <Label md={6} style={{ textAlign: "left", paddingLeft: "15px" }}><b style={{ fontWeight: 600 }}>Total :</b></Label>
                      <Label md={6} style={{ textAlign: "right", paddingRight: "15px" }}>820.00</Label>
                      <hr className='mt-0 mb-0'></hr>
                    </Col>

                  </Row>

                </div>
              </Modal>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}
CustomerDetail.propTypes = {
  t: PropTypes.any,
}
export default withRouter(withTranslation()(CustomerDetail))
